import React, { useEffect } from 'react';

function SkillBar({ name, percentage }) {
    useEffect(() => {
        // تنشيط تأثير تحريك الشريط عند التحميل
        const skillBar = document.getElementById(`skill-${name.replace(/\s+/g, '-')}`);
        if (skillBar) {
            setTimeout(() => {
                skillBar.style.width = `${percentage}%`;
            }, 300);
        }
    }, [name, percentage]);

    return (
        <div className="mb-4">
            <div className="d-flex justify-content-between mb-1">
                <span className="fw-medium">{name}</span>
                <span>{percentage}%</span>
            </div>
            <div className="progress" style={{ height: '10px' }}>
                <div
                    id={`skill-${name.replace(/\s+/g, '-')}`}
                    className="progress-bar skill-bar-fill bg-primary"
                    role="progressbar"
                    aria-valuenow={percentage}
                    aria-valuemin="0"
                    aria-valuemax="100">
                </div>
            </div>
        </div>
    );
}

export default SkillBar;